import React, {Component} from 'react';
import {Card, Dropdown, Grid, Input, Button} from 'semantic-ui-react';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import ProgressBar from '../../../common/components/progressBar';
import TableAmountReport from './table';

const today = moment();

class AmountReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'startDateFilter': today.format(noTimeZoneShortISODate),
      'endDateFilter': today.format(noTimeZoneShortISODate),
      'providerTmp': 'all',
      'providerSelected': 'all',
    };
    this.changeStartDate = this.changeStartDate.bind(this);
    this.changeEndDate = this.changeEndDate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateDataForProvider = this.updateDataForProvider.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.handleDownloadClick = this.handleDownloadClick.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.ProviderAmountReport, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.loadProviders({'withOrigin': true});
    if (this.props.location.search) {
      this.searchDefaultQuery();
      return;
    }
    this.props.fetchAmountTotals({'year': moment().year()});
    this.props.clearAmountReportDetail();
  }

  searchDefaultQuery() {
    const search = new URLSearchParams(this.props.location.search);
    const month = search.get('month') ? parseInt(search.get('month'), 10) : moment().month();
    const year = search.get('year') ? parseInt(search.get('year'), 10) : moment().year();
    this.props.fetchAmountTotals({'year': year});
    const firstDayQuery = moment([year, month - 1, 1]).format(noTimeZoneShortISODate);
    const lastDayQuery = moment(firstDayQuery)
      .endOf('month')
      .format(noTimeZoneShortISODate);
    const filters = {
      'initialDate': firstDayQuery,
      'finalDate': lastDayQuery,
    };
    this.changeStartDate(moment([year, month - 1, 1]));
    this.changeEndDate(moment(firstDayQuery).endOf('month'));
    this.props.fetchAmountReportDetail(filters);
  }

  fetchAmountReport() {
    const filters = this.getFilters();
    this.props.fetchAmountReportDetail(filters);
  }

  fetchTotals() {
    const {startDateFilter} = this.state;
    const year = moment(startDateFilter).year();
    this.props.fetchAmountTotals({'year': year});
  }

  fetchDownload() {
    const filters = this.getFilters();
    this.props.fetchDownloadAmountReportDetail(filters);
  }

  handleClearClick() {
    this.setState({
      'startDateFilter': today.format(noTimeZoneShortISODate),
      'endDateFilter': today.format(noTimeZoneShortISODate),
      'providerTmp': 'all',
      'providerSelected': 'all',
    });
    this.props.clearAmountReportDetail();
    this.props.fetchAmountTotals({'year': moment().year()});
  }

  getFilters() {
    const {startDateFilter, endDateFilter, providerSelected} = this.state;
    const filters = {
      'initialDate': startDateFilter,
      'finalDate': endDateFilter,
    };
    if (providerSelected && providerSelected !== 'all') {
      filters.provider = providerSelected;
    }
    return filters;
  }

  handleSearchClick() {
    this.fetchAmountReport();
    this.fetchTotals();
  }

  handleDownloadClick() {
    this.fetchDownload();
  }

  getProviders() {
    const dealers = this.props.providers.map((dealer) => {
      return {'text': dealer.name, 'value': dealer.code};
    });
    dealers.unshift({'text': 'Todos los proveedores', 'value': 'all'});
    return dealers;
  }

  changeStartDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    const {startDateFilter, endDateFilter} = this.state;
    if (dateFormatted === startDateFilter) {
      return;
    }
    this.updateFilter(dateFormatted, 'startDateFilter');

    if (
      !endDateFilter ||
      (endDateFilter && moment(date) > moment(endDateFilter)) ||
      moment(dateFormatted).year() !== moment(endDateFilter).year()
    ) {
      this.updateFilter(dateFormatted, 'endDateFilter');
    }
  }

  changeEndDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    if (dateFormatted === this.state.endDateFilter) {
      return;
    }
    this.updateFilter(dateFormatted, 'endDateFilter');
  }

  updateFilter(value, name) {
    const newState = {};
    newState[name] = value;
    this.setState(newState, () => this.updateDataForProvider());
  }

  handleChange(event, {name, value}) {
    const newName = name.concat('Tmp');
    this.updateFilter(value, newName);
  }

  updateDataForProvider() {
    const {providerSelected, providerTmp} = this.state;
    if (providerSelected === providerTmp) {
      return;
    }
    this.setState({'providerSelected': providerTmp});
  }

  render() {
    const {startDateFilter, endDateFilter, providerTmp} = this.state;
    const {loadingProviders, loadingAmountDetail, downloading} = this.props;

    return (
      <div className='provider-specials-orders'>
        <Card raised fluid>
          <Card.Content>
            <Grid>
              <Grid.Row>
                <Grid.Column width='8' textAlign='left'>
                  <h2>Reporte de uso de Montos para pedidos Aéreos y VOR</h2>
                </Grid.Column>
                <Grid.Column width='8' textAlign='right'>
                  <Button
                    secondary
                    onClick={this.handleClearClick}
                    content='LIMPIAR'
                    disabled={loadingProviders || loadingAmountDetail || downloading}
                  />
                  <Button
                    primary
                    content='EXPORTAR A EXCEL'
                    disabled={loadingProviders || loadingAmountDetail || downloading}
                    onClick={this.handleDownloadClick}
                  />
                  <Button
                    primary
                    content='BUSCAR'
                    className='toyota-primary'
                    disabled={loadingProviders || loadingAmountDetail}
                    onClick={this.handleSearchClick}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={3} stretched textAlign='left'>
                <Grid.Column>
                  <label>
                    <strong>Fecha Inicial</strong>
                  </label>
                  <DatePicker
                    customInput={<Input icon='calendar' size='small' />}
                    dateFormat={dateFormatPicker}
                    selected={startDateFilter ? moment(startDateFilter, noTimeZoneShortISODate).toDate() : null}
                    onChange={this.changeStartDate}
                    disabled={loadingAmountDetail}
                    locale='es'
                    placeholderText='Fecha Inicio'
                    maxDate={moment().endOf('year').toDate()}
                  />
                </Grid.Column>
                <Grid.Column>
                  <label>
                    <strong>Fecha Final</strong>
                  </label>
                  <DatePicker
                    customInput={<Input icon='calendar' size='small' />}
                    dateFormat={dateFormatPicker}
                    selected={endDateFilter ? moment(endDateFilter, noTimeZoneShortISODate).toDate() : null}
                    onChange={this.changeEndDate}
                    disabled={!startDateFilter || loadingAmountDetail}
                    minDate={moment(startDateFilter).toDate()}
                    placeholderText='Fecha Fin'
                    maxDate={moment(startDateFilter).endOf('year').toDate()}
                    locale='es'
                  />
                </Grid.Column>
                <Grid.Column>
                  <label>
                    <strong>Proveedor</strong>
                  </label>
                  <Dropdown
                    selection
                    options={this.getProviders()}
                    search
                    value={providerTmp}
                    name='provider'
                    loading={loadingProviders}
                    disabled={loadingAmountDetail}
                    onChange={this.handleChange}
                    placeholder='Seleccionar'
                    noResultsMessage='Proveedor no encontrado'
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={7}>
                  <label>
                    <strong>Año: </strong>
                    {moment(startDateFilter).year()}
                    <strong> | Autorizado: </strong>{'$'}{getNumericValue(this.props.totalAmount || 0, 2)}
                    <strong> | Consumido: </strong>{'$'}{getNumericValue(this.props.realAmount || 0, 2)}
                    <strong> | Saldo: </strong>$
                    {getNumericValue((this.props.totalAmount - this.props.realAmount).toFixed(2) || 0, 2)}
                  </label>
                  <ProgressBar
                    amountColors
                    hideLabel
                    hideIcon
                    label={'Pedidos'}
                    partialQuantity={this.props.realAmount || 0}
                    totalQuantity={this.props.totalAmount || 0}
                  />
                </Grid.Column>
                <Grid.Column width={5}></Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Content>
        </Card>
        <Card raised fluid>
          <Card.Content>
            <Grid textAlign='left'>
              <Grid.Row columns={1}>
                <Grid.Column>
                  <TableAmountReport />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Content>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loadingProviders': state.provider.loading,
    'providers': state.provider.list,
    'loadingAmountDetail': state.amountReportDetail.loading,
    'totalAmount': state.amountTotals.totalAmount,
    'realAmount': state.amountTotals.realAmount,
    'permissions': state.session.permissions,
    'downloading': state.amountReportDetail.downloading,
    'push': ownProps.history.push,
    'location': ownProps.history.location,
  };
};

const {
  loadProviders,
  fetchAmountTotals,
  fetchAmountReportDetail,
  fetchDownloadAmountReportDetail,
  clearAmountReportDetail,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  loadProviders,
  fetchAmountTotals,
  fetchAmountReportDetail,
  fetchDownloadAmountReportDetail,
  clearAmountReportDetail,
})(AmountReport));
